export default __webpack_public_path__ + "static/media/emoji-happy.9bca4335.svg";